
import React, { PureComponent } from 'react';

import { translate } from '../../../base/i18n';
import {
    IconCameraEmptyDisabled
} from '../../../base/icons';
import { BaseIndicator } from '../../../base/react';

/**
 * The type of the React {@code Component} props of {@link VideoMutedIndicator}.
 */
type Props = {

  /**
   * From which side of the indicator the tooltip should appear from.
   */
  tooltipPosition: string,
};

/**
 * React {@code Component} for showing a video muted icon with a tooltip.
 *
 * @augments Component
 */
class VideoMutedIndicator extends PureComponent<Props> {
    /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   */
    render() {
        return (
            <BaseIndicator
                className = 'videoMuted toolbar-icon'
                icon = { IconCameraEmptyDisabled }
                iconId = 'camera-disabled'
                iconSize = { 17 }
                tooltipKey = { this.props.t('videothumbnail.videomute') }
                tooltipPosition = { 'bottom-right' } />
        );
    }
}

export default translate(VideoMutedIndicator);
